import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Tag, LayoutList, Palette, MessageSquare } from 'lucide-react';

const TABS: Array<{
  path: string;
  label: string;
  icon: React.ElementType;
  description: string;
  disabled?: boolean;
}> = [
  { path: 'categorias', label: 'Categorias', icon: LayoutList,    description: 'Classifique seus contatos' },
  { path: 'tags',       label: 'Tags',       icon: Tag,           description: 'Marcadores de contexto'    },
  { path: 'whatsapp',   label: 'WhatsApp',   icon: MessageSquare, description: 'Integração e limites'      },
  { path: 'marca',      label: 'Identidade', icon: Palette,       description: 'Em breve', disabled: true  },
];

export function SettingsLayout() {
  return (
    <div className="flex flex-col gap-8 px-4 sm:px-6 py-6 max-w-screen-lg mx-auto w-full">
      {/* Header */}
      <div>
        <h1 className="font-display text-2xl font-bold text-ink">Configurações</h1>
        <p className="text-sm text-ink-muted mt-1">
          Personalize a plataforma para o seu tenant.
        </p>
      </div>

      {/* Tabs horizontais */}
      <nav className="flex gap-1 p-1 rounded-xl glass border border-hairline w-fit">
        {TABS.map((tab) => {
          if (tab.disabled) {
            return (
              <span
                key={tab.path}
                className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold text-ink-subtle cursor-not-allowed opacity-50"
              >
                <tab.icon className="h-4 w-4" />
                {tab.label}
                <span className="text-[9px] font-mono uppercase tracking-wider text-ink-subtle border border-hairline rounded px-1">
                  em breve
                </span>
              </span>
            );
          }
          return (
            <NavLink
              key={tab.path}
              to={tab.path}
              className={({ isActive }) =>
                `flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-all cursor-pointer ${
                  isActive
                    ? 'bg-accent/15 text-accent shadow-glow-xs'
                    : 'text-ink-muted hover:text-ink hover:bg-white/5'
                }`
              }
            >
              <tab.icon className="h-4 w-4" />
              {tab.label}
            </NavLink>
          );
        })}
      </nav>

      {/* Conteúdo da sub-rota */}
      <Outlet />
    </div>
  );
}
